import { useNavigate } from "react-router-dom";
import styles from '../cssModules/index.module.css';
import { Dropdown, Form } from 'react-bootstrap';


export default function BeltUpdate({ id, prod, setProd, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');
    // const { prodId } = useParams();
    // const [prod, setProd] = useState({});
    const navigate = useNavigate();

    const userSegment = ['Men', 'Women', 'Unisex'];

    const size = ['XS  (34 cm)', 'S (36 cm)', 'M (38 cm)', 'L (40 cm)', 'XL (42 cm)', '2XL (44 cm)', '3XL (46 cm)', '4XS (48 cm)', '5XL (50 cm)', '6XL (52 cm)', '7XL (54 cm)', '8XL (56 cm)', 'Free'];

    const material = [
        'Leather',
        'Cotton',
        'Silk',
        'Art Silk',
        'Chiffon',
        'Crepe',
        'Denim',
        'Down',
        'Faux Fur',
        'Felt',
        'Fleece',
        'Georgette',
        'Linen',
        'Modal',
        'Net',
        'Rayon',
        'Rubber',
        'Satin',
        'Sequined',
        'Synthetic',
        'Velvet',
        'Wool'
    ];

    const specialFeature = [
        'Adjustable',
        'Reversible',
        'Heavy Duty',
        'Auto Lock',
        'Durable',
        'Flame Resistant',
        'Lightweight',
        'Odor Resistant',
        'Quick Dry',
        'Rust Resistant',
        'Scratch Resistant',
        'Stain Resistant',
        'Stretch',
        'Wear Resistant',
        'Weather Resistant',
        'None'
    ]

    const color = ['red', 'darkred', 'tan', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];


    const careInstruction = [
        'Dry Clean Only',
        'Dry Cloth Clean',
        'Hand Wash Only',
        'Machine Wash',
        'Wet Wipe Clean'
    ];

    const embfeature = [
        'Lace',
        'Braid',
        'Logo',
        'Bead',
        'Eyelet',
        'Glitter',
        'Rhinestone',
        'Sequin',
        'Tassel',
        'None'
    ];

    const closureType = [
        'Buckle',
        'Clamp',
        'Clasp',
        'Clip',
        'Double Ring',
        'Flip',
        'Hook and Eye',
        'Hook and Loop',
        'Lace-up',
        'Pull On',
        'Pull-Through',
        'Ratchet',
        'Screw',
        'Snap',
        'Tie',
        'Twist Lock',
        'Zipper'
    ];

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)'];

    const stock = ['In stock', 'Out of stock'];

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/change/${id}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify(prod),
                credentials: 'include'
            })
            if (response.status === 200) {
                alert('Updated the product!');
                navigate('/manage');
            } else {
                await loginStatus();
                navigate('/login');
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProd(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod && (
                <div className={`${styles.sellerUpdate}`}>
                    <form id='uploadForm' onSubmit={handleSubmit}>
                        <div className={`${styles.updateIndividualMainDiv}`}>
                            <img src={`${apiURL}/images/${prod.photo1}`} alt='img' className={`${styles.updateIndividualImage}`} />
                            <div className={`${styles.sellerUpdateDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='userSegment'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='userSegment' name='userSegment' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='material'>
                                        Material
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='material' name='material' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.material} selected hidden>{prod.material}</option>
                                        {material.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='careInstruction'>
                                        Care instruction
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='careInstruction' name='careInstruction' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                        {careInstruction.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='specialFeature'>
                                        Special feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='specialFeature' name='specialFeature' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.specialFeature} selected hidden>{prod.specialFeature}</option>
                                        {specialFeature.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='embfeature'>
                                        Embellishment feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='embfeature' name='embfeature' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.embfeature} selected hidden>{prod.embfeature}</option>
                                        {embfeature.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' name='closureType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.closureType} selected hidden>{prod.closureType}</option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' name='active' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='name' defaultValue={prod.name} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='price' defaultValue={prod.oldPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="price" name='oldPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='dPrice'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='dPrice' defaultValue={prod.currentPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' name='weightCat' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock' defaultValue={prod.stock} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="Available stock" name='stock' />
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Size</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                                </div>

                            </div>
                            <input type="submit" value='UPDATE' className={`${styles.sellerUpdateButton}`} />
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}